import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { getLocale } from "react-i18nify";
import FormLabel from "@mui/material/FormLabel";
import { getSellerDetail, updateSellerPaytype } from "src/api/seller";
// import TextField from "@mui/material/TextField";
import { decryptData } from "../profile/DecryptData";
import Checkbox from '@mui/material/Checkbox';
import { Alert } from "@mui/material";

const Modal = styled.div`
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1200;
  animation: show 0.5s;
  @keyframes show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const WrapperTextField = styled.div`
  margin-bottom: 16px;

  width: fit-content;
  /* margin: 0 auto; */

  .MuiFormLabel-root, .MuiFormLabel-root.Mui-focused {
    color: #6c6c70;
  }
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiOutlinedInput-input {
    background: #fff;

    border-radius: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }
`;

const WrapperModal = styled.div`
  width: 80%;
  max-width: 600px;
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  padding: 30px 25px;
  min-width: 444px;
  animation: showModal 0.5s;
  @keyframes showModal {
    0% {
      transform: translate(-50%, -60%);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }
`;

const WrapperModalInside = styled.div`
  width: max-content;
  height: auto;
  // overflow-y: scroll;
  // overflow-x: hidden;
  /* margin-top: 0px; */
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }

  .Button-New-Brand {
    color: #ffffff;
    width: 98%;
    margin: 8px;
    display: flex;
    justify-content: center;
    background: #e04132;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-New-Brand:focus {
    background-color: #e04132;
  }
  .Button-New-Brand:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

const WrapperAlert = styled.div`
  position: fixed;
  top: -80px;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  @keyframes showAlert {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;
const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;

function ModalSetSellNow({ visible, onSave, close, title, image, id }) {
  const [dataSeller, setDataSeller] = useState({
    _id: id,
    is_sell: false,
    pay_type: "full",
    // minimum_amount: 0,
  });
  const [errorInfo, setErrorInfo] = useState({
    visible: false,
    textError: '',
    typeError: 'success',
  });
  const closeModal = () => {
    // setIsVisible(false)
    close(false);
  };

  useEffect(() => {
    if (id === undefined) return;
    (async () => {
      await getSellerDetail(id).then(async ({ data }) => {
        const decrypt = await decryptData(data);
        setDataSeller({
          ...dataSeller,
          is_sell: decrypt?.is_sell,
          pay_type: decrypt?.pay_type ?? 'full',
          // minimum_amount: decrypt?.minimum_amount ?? 0,
        });
      });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async () => {
    // console.log('---dataSeller---', dataSeller)
    await updateSellerPaytype(dataSeller)
      .then((res) => {
        setErrorInfo({
          ...errorInfo,
          visible: true,
          textError: "บันทึกข้อมูลสำเร็จ",
          typeError: "success",
        });
        setTimeout(() => {
          closeModal()
          setErrorInfo({
            ...errorInfo,
            visible: false,
            textError: "",
            typeError: "",
          });
        }, 1500);
      }).catch((err) => {
        setErrorInfo({
          ...errorInfo,
          visible: true,
          textError: err.response.data.message,
          typeError: "error",
        });
        setTimeout(() => {
          setErrorInfo({
            ...errorInfo,
            visible: false,
            textError: "",
            typeError: "",
          });
        }, 1500);
      })
  };
  
  const handlePaytype = (e) => {
    setDataSeller({
      ...dataSeller,
      pay_type: e.target.value,
    });
  };

  // const handleSetAmount = (e) => {
  //   const regex = /^[0-9]{0,3}$/;
  //   if (e.target.value === "" || regex.test(e.target.value)) {
  //     setDataSeller({
  //       ...dataSeller,
  //       minimum_amount: e.target.value,
  //     });
  //   }
  // };

  return (
    <Modal>
      <WrapperModal>
        <WrapperModalInside>
          <WrapperTextField style={{ width: "100%" }}>
            <FormControl>
              <FormLabel
                id="sell-now-checkbox-label"
                // sx={{ textAlign: 'center' }}
              >
                {getLocale() === "th" ? "กำหนดประเภทผู้ขาย" : "Set Sell Type"}
              </FormLabel>
              <FormControlLabel
                control={
                  <Checkbox
                    name="sell-now-checkbox"
                    sx={{
                      "&.Mui-checked": {
                        color: "#e04132",
                      },
                    }}
                    checked={dataSeller.is_sell}
                    onChange={(e) => {
                      setDataSeller({
                        ...dataSeller,
                        is_sell: e.target.checked,
                      });
                    }}
                  />
                }
                label="ขายเลย"
              />
            </FormControl>
          </WrapperTextField>

          <WrapperTextField style={{ width: "100%" }}>
            <FormControl
            // sx={{ width: '100%' }}
            >
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                // sx={{ textAlign: 'center' }}
              >
                {getLocale() === "th"
                  ? "กำหนดประเภทการจ่ายเงินร้านค้า"
                  : "Set Pay Type"}
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                // sx={{ justifyContent: 'space-around' }}
                name="row-radio-buttons-group"
                value={dataSeller.pay_type}
                onChange={handlePaytype}
              >
                <FormControlLabel
                  value="full"
                  control={
                    <Radio
                      // checked={dataSeller.pay_type === "full" ? true : false}
                      sx={{
                        color: "#e04132",
                        "&.Mui-checked": {
                          color: "#e04132",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={getLocale() === "th" ? "เต็มจำนวน" : "Full"}
                />
                <FormControlLabel
                  value="minimum"
                  control={
                    <Radio
                      sx={{
                        color: "#e04132",
                        "&.Mui-checked": {
                          color: "#e04132",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={getLocale() === "th" ? "จำนวนขั้นต่ำ" : "Minimum"}
                />
              </RadioGroup>
            </FormControl>
          </WrapperTextField>
          {/* <WrapperTextField
            style={{ display: "flex", margin: "0 auto" }}
          >
            <span style={{ margin: "auto 12px" }}>จำนวนขั้นต่ำ</span>
            <TextField
              disabled={dataSeller.pay_type === "full" ? true : false}
              className="TextField-without-border-radius"
              sx={{
                width: "55%",
                textAlign: "center",
              }}
              value={dataSeller?.minimum_amount}
              onChange={(e) => handleSetAmount(e)}
            />
            <span style={{ margin: "auto 12px" }}>บาท</span>
          </WrapperTextField> */}
        </WrapperModalInside>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={closeModal}
            className="Button-New-Brand"
            style={{
              background: "#fff",
              color: "#e04132",
              border: "1px solid #D9D9D9",
              borderRadius: "16px",
              display: "flex",
              width: "75px",
              height: "42px",
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleSubmit}
            className="Button-New-Brand"
            style={{
              background: "#e04132",
              color: "#fff",
              borderRadius: "16px",
              margin: "auto 12px",
              display: "flex",
              width: "75px",
              height: "42px",
            }}
          >
            ตกลง
          </Button>
        </div>

        {errorInfo.visible && (
          <WrapperAlert>
            <DivAlert>
              <Alert
                className="MuiPaper-root-MuiAlert-root"
                severity={errorInfo.typeError}
              >
                {errorInfo.textError}
              </Alert>
            </DivAlert>
          </WrapperAlert>
        )}
      </WrapperModal>
    </Modal>
  );
}

export default ModalSetSellNow;
